import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { STREAM__WITH_CURSOR__INITIALIZE, STREAM__WITH_CURSOR__SET_CURSOR, STREAM__WITH_CURSOR__FETCH, STREAM__WITH_CURSOR__FETCH_SUCCESS, STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE, STREAM__WITH_CURSOR__INSERT_ITEMS, fetchPrevious, fetchPreviousSuccess, emptyStream, resetStream, fetchAllSuccess } from './actions';
import { handleInitAction, handleFetchAction, handleFetchSuccessAction, handleFetchPreviousSuccessAction, commonActionHandlers, handleEmptyStream, handleResetStream, handleFetchAllSuccessAction } from '../base/actionHandlers';
import { handleInsertItemsAtOffsetAndSetCursorAction } from './actionHandlers';
import { StreamType } from '../types';
import { defaultStreamState } from '../constants';
const actionHandlers = _object_spread({
    [STREAM__WITH_CURSOR__INITIALIZE]: (streamState, action)=>{
        return _object_spread_props(_object_spread({}, handleInitAction(streamState, action)), {
            cursor: action.cursor,
            prevCursor: action.prevCursor
        });
    },
    [STREAM__WITH_CURSOR__SET_CURSOR]: (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
            cursor: action.cursor
        }),
    [STREAM__WITH_CURSOR__FETCH]: (streamState)=>handleFetchAction(streamState),
    [STREAM__WITH_CURSOR__FETCH_SUCCESS]: (streamState, action)=>{
        return _object_spread_props(_object_spread({}, handleFetchSuccessAction(streamState, action)), {
            cursor: action.cursor
        });
    },
    [STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE]: (streamState, action)=>{
        var _actionItems_filter, _this;
        const { items = [] } = streamState;
        const { items: actionItems, dedupeFunction = (item, existingItems)=>!existingItems.includes(item), cursor } = action, baseAction = _object_without_properties(action, [
            "items",
            "dedupeFunction",
            "cursor"
        ]);
        // we want to dedupe already existing items from the stream
        const filteredItems = (_this = actionItems) === null || _this === void 0 ? void 0 : (_actionItems_filter = _this.filter) === null || _actionItems_filter === void 0 ? void 0 : _actionItems_filter.call(_this, (item)=>dedupeFunction(item, items));
        return _object_spread_props(_object_spread({}, handleFetchSuccessAction(streamState, _object_spread_props(_object_spread({}, baseAction), {
            items: filteredItems
        }))), {
            cursor
        });
    },
    [STREAM__WITH_CURSOR__INSERT_ITEMS]: (streamState, action)=>handleInsertItemsAtOffsetAndSetCursorAction(streamState, action),
    [fetchPrevious.toString()]: handleFetchAction,
    [fetchPreviousSuccess.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleFetchPreviousSuccessAction(streamState, action)), {
            prevCursor: action.payload.prevCursor
        }),
    [fetchAllSuccess.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleFetchAllSuccessAction(streamState, action)), {
            prevCursor: undefined,
            cursor: undefined
        }),
    [emptyStream.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleEmptyStream(streamState, action)), {
            cursor: undefined,
            prevCursor: undefined
        }),
    [resetStream.toString()]: (streamState, action)=>_object_spread_props(_object_spread({}, handleResetStream(streamState, action)), {
            cursor: undefined,
            prevCursor: undefined
        })
}, commonActionHandlers);
const reducer = (streamState = _object_spread_props(_object_spread({}, defaultStreamState), {
    streamType: StreamType.WITH_CURSOR
}), action)=>{
    const handler = actionHandlers[action.type];
    return handler && handler(streamState, action) || streamState;
};
export default reducer;
